export default (state, actions) => {
    return Object.assign({}, state, { match: actions.match, oldMatch: state.match });
};